import utils from './utils'

const misc = (project) => {
  return [
    utils.unitField({
      prepend: 'meta.',
      customUnits: project.meta.units || [],
    }),
    utils.rateTable({
      inheritUnit: true,
    }),
  ]
}

export default misc